module.exports = __webpack_public_path__ + "static/img/6.9701761.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/6.png
// module id = MVnW
// module chunks = 0